import React from "react"
import { Link } from "react-router-dom";

export default class FormFooterLinks extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="row">
				<div className="col-sm-12">
					{
						this.props.left
						?
						<div className="pull-left">
							<Link to={this.props.left.path}>{this.props.left.text}</Link>
						</div>
						:
						null
					}
					{
						this.props.right
						?
						<div className="pull-right">
							<Link to={this.props.right.path}>{this.props.right.text}</Link>
						</div>
						:
						null
					}
				</div>
			</div>
		);	
	}

}